import { Injectable } from '@angular/core';
import { APP } from "./../constants";
import { HttpClient } from '@angular/common/http';

@Injectable()
export class EmpresaService {
  apiUrl = APP.ApiEndpoint;

  constructor(private _http: HttpClient) { }

  public listarMain(data: any, callback) {
    const url = `${this.apiUrl}/api/empresa/main`;
    const self = this;
    return this._http.post(url, data).subscribe(
      result => { callback(result); }
    )
  }

  public listarEmpresa(data: any, callback) {
    const url = `${this.apiUrl}/api/empresa/`;
    const self = this;
    return this._http.post(url, data).subscribe(
      result => { callback(result); }
    )
  }

}
